import MainPage from './pages/main/MainPage';
import EpisodePage from './pages/episode/EpisodePage';

import { WidgetPage } from '@wix/podcasts-common/dist/widget';

import { IRoutePage } from './lib/router/types';

const routes: IRoutePage[] = [
  {
    path: '/:_(q/)?:query?',
    component: MainPage,
    page: WidgetPage.MAIN,
  },
  {
    path: '/episode/:id/:slug?',
    component: EpisodePage,
    page: WidgetPage.EPISODE,
  },
];

export default routes;
